export default __webpack_public_path__ + "static/emergency-access-a801d43737034a806dde1f58850d34f3.jpg";